import React from 'react';
import '../styles/Home.css';

function Home() {
  return (
    <div className="home">
      <div className="logo-container">
        <img 
          src="https://www.deere.co.in/assets/images/deere-logo-agriculture.svg" 
          alt="John Deere Logo" 
          className="deere-logo"
        />
      </div>
    </div>
  );
}

export default Home;
